import { useInView } from '@hooks/useScroll';
import { Mail, Send, Facebook, Instagram } from 'lucide-react';
import { useSiteText } from '@/lib/SiteTextContext';

export function ContactSection() {
  const { t } = useSiteText();
  const { ref, isInView } = useInView();



  return (
    <section id="contact" className="py-20 md:py-32 bg-ocean-blue text-white">
      <div className="container mx-auto px-6 md:px-12 lg:px-24">
        <div
          ref={ref}
          className={`transition-all duration-700 ease-sail ${isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
        >
          {/* Contact Info */}
          <div>
            <div className="flex items-center gap-3 mb-6">
                            <Send className="w-6 h-6 text-accent-gold" />
              <span className="text-sm tracking-[0.3em] uppercase font-medium text-misty-blue">
                {t('contact.label')}
              </span>
            </div>

                        <h2 className="font-display text-4xl md:text-5xl font-bold mb-6 text-wave">
              {t('contact.title')}
            </h2>

            <p className="text-misty-blue/80 font-light leading-relaxed mb-10">
              {t('contact.text')}
            </p>

            <div className="flex flex-col gap-6">
              <div className="flex items-start gap-4">
                <Mail className="w-6 h-6 text-accent-gold flex-shrink-0 mt-1" />
                <div>
                  <p className="font-bold mb-1">Email</p>
                  <p className="text-misty-blue/70">chkzlok@gmail.com</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div>
                  <p className="font-bold mb-2">Znajdź nas</p>
                  <div className="flex gap-5">
                    <a
                      href="https://www.facebook.com/ChodzieskiKlubZeglarskiLOK"
                      target="_blank"
                      rel="noreferrer"
                      className="link-underline flex items-center gap-2 text-misty-blue/80 hover:text-white transition-colors"
                    >
                      <Facebook size={20} /> Facebook
                    </a>
                    <a
                      href="https://www.instagram.com/chkz.lok_/"
                      target="_blank"
                      rel="noreferrer"
                      className="link-underline flex items-center gap-2 text-misty-blue/80 hover:text-white transition-colors"
                    >
                      <Instagram size={20} /> Instagram
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Map */}
          <div className="mt-12">
            <div className="bg-white/5 rounded-2xl overflow-hidden border border-white/10 p-4">
              <iframe
                src="https://maps.google.com/maps?q=52.989459,16.924349&z=15&output=embed"
                width="100%"
                height="300"
                style={{ border: 0, borderRadius: '12px' }}
                loading="lazy"
                title="Lokalizacja ChKŻ LOK"
              />
              <p className="text-center text-sm text-misty-blue/70 mt-3">
                52.989459, 16.924349 — Chodzież, Polska
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
